<template>
  <li :class="{ 'is-active': isActive }">
    <router-link :to="path">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </router-link>
  </li>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  path: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  selectedRoutePrefix: {
    type: [String, Array] as PropType<string | string[]>,
    required: true,
  },
});

const route = useRoute();

const activeRouteName = computed(() => String(route?.name || ''));

const prefixes = computed(() => {
  if (typeof props.selectedRoutePrefix === 'string') {
    return [props.selectedRoutePrefix];
  } else if (Array.isArray(props.selectedRoutePrefix)) {
    return props.selectedRoutePrefix;
  }
  return [];
});
const isActive = computed(() => prefixes.value.some((p: string) => routeStartsWith(p)));

function routeStartsWith(prefix: string) {
  return activeRouteName.value.startsWith(prefix);
}
</script>
